
import debug from 'bows/dist/bows.min.js';
import $ from "jquery";
import fitvid from "./base/_fitvid";

const log = debug("custom-player");

class customPlayer {

  constructor() {

    log('_jwplayer.js constructor')

    this.src = '/themes/custom/phillips/assets/jwplayer/jwplayer.js';
    this.key = "jgSneyZ8dP7DiA9RxDTM+Kb1bR2MCQiHyAsw1d9ro10=";
    this.players = [];
    this.init = false;

    this.$videos = $('div.mmplayer');

    log(this.$videos)

    this.$videos.each((i, v) => {
      let data = $(v).data('playlist').replace(',]', ']');
      log('data-' + i, data);
      let playlist = JSON.parse(data);
      let id = $(v).attr('id');
      // log(id, playlist);
      this.addPlayer({
        id: id,
        playlist: playlist
      })
    });

  }



  load() {

    log('load', this.init);

    if (false === this.init) {
      let self = this;
      this.init = true;

      log('loading -- only once!?')

      var script = document.createElement('script');
      script.onload = () => {
        log('jwplayer.js loaded')
        setTimeout(() => {
          log(jwplayer, self.key)
          jwplayer.key = self.key;
          self.loadPlayer();
        }, 500);
      };
      script.src = this.src;
      document.head.appendChild(script); //or something of the likes

    }
  }

  addPlayer(obj) {
    // log(obj);
    this.players.push(obj);
    this.load();
  }

  loadPlayer() {
    // let self = this;
    log('loadPlayer', this.players.length);

    if (this.players.length === 0) {
      this.init = false;
      return;
    }

    let item = this.players.shift();

    // log('jw', jwplayer(item.id), item.id);

    let player = jwplayer(item.id).setup({
      playlist: item.playlist
    }).on('play',() => {
      log('Playback just started for: ' + item.id);
      this.pauseOthers(item.id);
    });

    setTimeout(() => {
      fitvid();
      this.loadPlayer();
    }, 500);

  }

  test() {
    console.log('test');
  }

  pauseOthers(id) {
    log('pauseOthers', item.id);
    var videos = document.querySelectorAll('.jwplayer');
    for (let i = 0; i < videos.length; i++) {
      if (id != videos[i].id) {
        jwplayer(videos[i].id).pause(true);
        // log('Pausing: ' + videos[i].id);
      }
    }
  }

}
export default customPlayer;
